import { type ReactNode } from 'react';

import {
    type PrimaryTabDefinition,
    PrimaryTabs,
} from '@apps/web/components/admin/trace_views/primary_tabs';

export const CONVERSATION_AGENT_TRACE_PRIMARY_TABS: ReadonlyArray<PrimaryTabDefinition> =
    [
        { label: 'Rendered', value: 'rendered-chat' },
        { label: 'Agent Conversation', value: 'model' },
        { label: 'Graph', value: 'graph' },
        { label: 'Events', value: 'events' },
        { label: 'Files', value: 'files' },
        { label: 'Requests', value: 'episodes' },
        { label: 'Subagents', value: 'subagents' },
        { label: 'Playground', value: 'playground' },
    ];

export const RUN_AGENT_TRACE_PRIMARY_TABS: ReadonlyArray<PrimaryTabDefinition> =
    [
        { label: 'Rendered', value: 'rendered-chat' },
        { label: 'Events', value: 'events' },
        { label: 'Files', value: 'files' },
        { label: 'Requests', value: 'episodes' },
        { label: 'Subagents', value: 'subagents' },
    ];

export function AgentTracePrimaryTabs({
    children,
    tabs,
}: {
    readonly children: ReactNode;
    readonly tabs: ReadonlyArray<PrimaryTabDefinition>;
}) {
    return (
        <PrimaryTabs tabs={tabs} defaultValue="rendered-chat">
            {children}
        </PrimaryTabs>
    );
}
